export {default} from './medium-editor.vue'